<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
        :summaryOptions="{
            enabled: true,
            columns: [
                'totalPaid',
                'paid',
                'credit',
                'debit',
                'scheduledPayments',
                'previousBalance',
                'balance',
            ],
        }"
    ></dx-grid>
</template>

<script>
import { formatCurrency } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Day Camp Accounts",
        columns: [
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "LapidusAccountView",
                format: "",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "country",
                label: "Country",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bungalow",
                label: "Bungalow",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lapidusBungalow",
                label: "Lapidus Bungalow",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "students",
                label: "Students",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "note",
                label: "Note",
                format: "",
                type: "number",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "balance",
                label: "Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "previousBalance",
                label: "Previous Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "debit",
                label: "Billed",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "totalPaid",
                label: "Total Paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "credit",
                label: "Credit",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "paid",
                label: "Paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "scheduledPayments",
                label: "ScheduledPayments",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Non UTA",
                field: "nonUTA",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Lunch Document Status",
                field: "lunchDocumentStatus",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Card Printed",
                field: "cardPrinted",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                field: "cardPrintDate",
                label: "Card Print Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],

        regID: "",
        url: "",
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onRowClicked;
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.actions.push({
                text: "Add Family",
                action: this.addFamily,
            });

            this.url = "lapidusDayCampAccounts?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/lapidusDayCamp/getRegTerms");
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "LapidusAccountView",
                params: { id: row.accountID, reg_id: row.regID },
                query: {
                    isGirls: true,
                },
            });
        },
        addFamily() {
            this.$router.push({
                name: "LapidusApply",
                query: {
                    isGirls: true,
                },
            });
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "lapidusDayCampAccounts?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
